<template>
	<div class="dl-register-container" v-on:click="close">
		<transition name="dl-register-toggle" v-on:after-leave="afterHidden" v-on:before-enter="onAnimationStart" v-on:before-leave="onAnimationStart" v-on:after-enter="onAnimationEnd">
			<div v-if="show" class='dl-register' v-on:click="stopClickPropagation($event)">
				<div>
					<h1>{{$t('str.CreateAccount')}}</h1>
					<div class='line-container'>
						<div>
							<label>{{$t('str.FirstName')}}</label>
							<input v-model="firstname" :placeholder="$t('str.YourFirstName')" :class="invalidFields & keys.firstname ? 'invalid' : ''" :disabled="isRegistering" />
						</div>
						<div>
							<label>{{$t('str.LastName')}}</label>
							<input v-model="lastname" :placeholder="$t('str.YourLastName')" :class="invalidFields & keys.lastname ? 'invalid' : ''" :disabled="isRegistering" />
						</div>
					</div>
					<div class="line">
						<label>{{$t('str.EmailAddress')}}</label>
						<input v-model="email" :placeholder="$t('str.Email')" :class="invalidFields & keys.email ? 'invalid' : ''" :disabled="isRegistering" />
					</div>
					<div class='line-container'>
						<div>
							<label>{{$t('str.Password')}}</label>
							<input type='password' v-model="password1" :placeholder="$t('str.Password')" :class="invalidFields & keys.password1 ? 'invalid' : ''" :disabled="isRegistering" />
						</div>
						<div>
							<label>{{$t('str.ReConfirmPassword')}}</label>
							<input type='password' v-model="password2" :placeholder="$t('str.ReConfirmPassword')" :class="invalidFields & keys.password2 ? 'invalid' : ''" :disabled="isRegistering" />
						</div>
					</div>
					<div class="line">
						<label>{{$t('str.Captcha')}}</label>
						<div>
							<div name='captcha' :class="['g-recaptcha', invalidFields & keys.captcha ? 'invalid' : '']" :data-sitekey="rcaptSigKey"></div>
						</div>
					</div>
					<div v-if="!!errorMessage" class="error">{{errorMessage}}</div>
					<p class='footer'>
						<button v-on:click='reset' class="bt-reset" :disabled="isRegistering">{{$t('str.Reset')}}</button>
						<button v-on:click='signup' :disabled="isRegistering">{{$t('str.Signup')}}</button>
					</p>
				</div>
				<a v-on:click="close" class="close-button">
			        <i class="fa fa-times"></i>
			    </a>
			</div>
		</transition>
	</div>
</template>

<script>

const CAPTCHA_SIGKEY = '6LfsJyETAAAAAL89cTI6B4ka56Yr-HQsb_WPv6iY';
const regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default {
	props: {
		service: Object
	},

	data() {
		return {
			firstname: '',
			lastname: '',
			email: '',
			password1: '',
			password2: '',
			show: false,
			rcaptSigKey: CAPTCHA_SIGKEY,
			rcaptId: 0,
			errorMessage: undefined,
			invalidFields: 0,
			keys: {
				firstname: 0x01,
				lastname: 0x02,
				email: 0x04,
				password1: 0x10,
				password2: 0x20,
				captcha: 0x40
			},
			isRegistering: false
		};
	},
	
	mounted() {
        setTimeout(() => {
            this.show = true;
        }, 1);
    },

	methods: {
		signup() {
			if (!window.grecaptcha) {
				console.error("Undefined captcha");
				return;
			}

			window.g_recaptcha_response = window.grecaptcha.getResponse(this.rcapt_id);
			
			this.invalidFields = 0;
			this.errorMessage = undefined;

			if (!window.g_recaptcha_response || window.g_recaptcha_response.length === 0) {
				this.invalidFields |= this.keys.captcha;
			}

			this.invalidFields |= this.firstname.trim() === '' ? this.keys.firstname : 0;
			this.invalidFields |= this.lastname.trim() === '' ? this.keys.lastname : 0;
			this.invalidFields |= this.password1.trim() === '' ? this.keys.password1 : 0;
			this.invalidFields |= this.password2.trim() === '' ? this.keys.password2 : 0;
			this.invalidFields |= regEmail.test(this.email) ? 0 : this.keys.email;

			if (this.password1 !== this.password2) {
				this.invalidFields |= this.keys.password1;
				this.invalidFields |= this.keys.password2;
			}

			if (this.invalidFields && this.invalidFields === this.keys.password1|this.keys.password2 && this.password1.trim() !== '') {
				this.errorMessage = this.$t('str.FailRegisterPassordMisMatch');
				return;
			}

			if (this.invalidFields === this.keys.email) {
				this.errorMessage = this.$t('str.FailRegisterInvalidEmail');
				return;
			}

			if (this.invalidFields) {
				this.errorMessage = this.$t('str.FailRegisterMissingData');
				return;
			}

			// Save it in case the user changes it during registration
			let email = this.email;
			let password = this.password1;

			this.isRegistering = true;

			this.service.registerUser(this.firstname, this.lastname, email, password).then(() => {
				this.service.login('dialogloop', window.location.href, email, password).then(() => {
					this.close();
				}).catch((err) => {
					this.isRegistering = false;
					console.log(err);
					this.errorMessage = this.$t('str.LoginFailed');
				});
			}).catch((err) => {
				this.isRegistering = false;
				console.log(err);
				this.errorMessage = this.$t('str.FailRegisterUnknownReason');
			});
		},

		reset() {
			this.firstname = '';
			this.lastname = '';
			this.password1 = '';
			this.password2 = '';
			this.email = '';
		},

		close() {
            this.show = false;
        },

        afterHidden() {
        	this.onAnimationEnd();
            this.$emit('close');
        },

		stopClickPropagation() {
			if (event && event.stopPropagation) {
                event.stopPropagation();
            }
		},

		onAnimationStart() {
			document.body.style.overflowY = 'hidden';
			this.$el.style.overflowY = 'hidden';
		},

		onAnimationEnd() {
			document.body.style.overflowY = 'default';
			this.$el.style.overflowY = 'auto';

			if (!this.show) {
				return;
			}

	        if (window.grecaptcha) {
			    this.rcaptId = window.grecaptcha.render(this.$el.querySelector('[name="captcha"]'), {
					sitekey : this.rcaptSigKey
				});
			}
		}
	}
}

</script>

<style lang="scss">

.dl-register-toggle-enter-active, .dl-register-toggle-enter-to, .dl-register-toggle-leave-active {
    transition: all 0.3s;
}

.dl-register-toggle-enter, .dl-register-toggle-leave-to {
    opacity: 0;
    transform: translateY(300px);
}

.dl-register-container {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 40px 10px 10px 10px;
    overflow: auto;
}

.dl-register {
	background: #fff;
	width: 100%;
	font-family: "Poppins", sans-serif;
	padding: 15px 15px 20px 15px;
	box-sizing: border-box;
	position: relative;
	max-width: 600px;
	margin: 0 auto;

	& > div {
		width: 100%;
	}

	h1 {
		text-align: center;
		color: #d4451d;
		font-size: 1em;
    	font-weight: 100;
    	margin-bottom: 30px;
	}

	.line-container {
		& > div {
		    padding: 0 5px;
		    box-sizing: border-box;
		}
	}

	@media screen and (min-width: 460px) {
        .line-container {
			overflow: hidden;

			& > div {
				float: left;
				width: 50%;
			    padding: 0 5px;
			    box-sizing: border-box;
			}
		}
    }

    @media screen and (max-width: 460px) {
        .line-container {
			& > div {
				width: 100%;
			}
		}
    }

	.line {
		width: 100%;
	    padding: 0 5px;
	    box-sizing: border-box;
	}

	label {
	    font-size: 0.8rem;
    	color: #9e9e9e;
    	padding-left: 5px;
    }

	input {
		padding: 10px;
		width: 100%;
		margin-bottom: 10px;
		border: 1px solid #d2d8d8;
	    font-size: 0.8rem;
	    color: #242424;
	    box-sizing: border-box;
	    min-width: 200px;
	}

	input:focus {
		outline: none;
	}

	input:disabled {
		color: #a2a2a2;
	}

	button {
		background-color: #d4451d;
		color: #fff;
		text-decoration: none;
		font-size: 0.8em;
		letter-spacing: 0.5px;
		padding: 10px 35px;
		box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
		border: none;
		border-radius: 0;
		outline: 0;
		text-transform: uppercase;
		margin: 10px 0 0 0;
		cursor: pointer;
	}

	button:disabled {
		background-color: #a2a2a2;
		cursor: default;
	}

	p {
		margin: 0;
		-moz-user-select: none;
	    -webkit-user-drag: none;
	    -webkit-user-select: none;
	    -ms-user-select: none;
	}

	.g-recaptcha {
		display: inline-block;
	}

	.close-button {
		position: absolute;
		right: 20px;
		top: 10px;
		color: #d4451d;
		cursor: pointer;
	}

	.bt-reset {
		background: none;
		color: black;
		cursor: pointer;
	}

	.bt-reset:disabled {
		background: none;
		color: #a2a2a2;
		cursor: default;
	}

	.footer {
		text-align: right;
	}

	.error {
		text-align: center;
		color: #d4451d;
		padding: 15px 0 10px 0;
		font-size: 0.8em;
	}

	.invalid {
		border: 2px solid red;
	}
}

</style>



// WEBPACK FOOTER //
// Register.vue?37449954